import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "@emotion/styled-base";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Children } from 'react';
import { themeGet } from 'styled-system';
import PropTypes from 'prop-types';
import flattenChildren from 'react-flatten-children';
import { Flex, Icon } from "../";
import Breadcrumb from "./Breadcrumb";

var Container = /*#__PURE__*/_styled(Flex, {
  target: "e1ilpbdd0",
  label: "Container"
})("*:last-child{font-weight:", themeGet('fontWeights.bold'), ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var Chevron = /*#__PURE__*/React.createElement(Icon, {
  name: "chevronRight",
  color: "greys.alto",
  size: 22,
  mx: 1
});

var prepareCrumbs = function prepareCrumbs(children) {
  var flattened = flattenChildren(children);
  var hasMultiple = flattened.filter(Boolean).length > 1;
  var current = hasMultiple ? flattened[flattened.length - 1] : children;
  var labelled = /*#__PURE__*/React.cloneElement(current, {
    'aria-current': 'page'
  });

  if (hasMultiple) {
    flattened.splice(flattened.length - 1, 1, labelled);
    var separated = flattened.reduce(function (prev, curr) {
      return [prev, Chevron, curr];
    });
    return Children.toArray(separated);
  } else {
    return labelled;
  }
};

var Breadcrumbs = function Breadcrumbs(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Container, _extends({
    verticalAlign: "center"
  }, props), prepareCrumbs(children));
};

Breadcrumbs.propTypes = _objectSpread({
  children: PropTypes.node.isRequired
}, Flex.propTypes);
Breadcrumbs.defaultProps = _objectSpread({}, Flex.defaultProps);
Breadcrumbs.Crumb = Breadcrumb;
export default Breadcrumbs;